import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { SharedUserAuthorizationService } from "@mrdm-self-service-frontend/shared/data-access-authorization";
import { NameId } from "@mrdm-self-service-frontend/shared/types";
import { of } from "rxjs";
import { Observable } from "rxjs/internal/Observable";
import { map, switchMap, tap } from "rxjs/operators";
import { OrganizationPermissionService } from "./organization-permission.service";

@Injectable({
    providedIn: "root"
})
export class OrganizationAuthorizationGuard  {
    private _router = inject(Router);
    private _organizationPermissions = inject(OrganizationPermissionService);
    private _authService = inject(SharedUserAuthorizationService);


    canActivate(
        next: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
        return this._checkAccess(next.routeConfig, Number(next.params.id));
    }

    private _checkAccess(route: Route | null, organizationId: number): Observable<boolean> {
        return this.isAllowedOrganization(organizationId).pipe(
            switchMap((isAllowedOrganization: boolean) => {
                if (isAllowedOrganization) {
                    this._authService.setOrganizationId(organizationId);
                    const expected: string[] = route?.data?.expectedPermissions;
                    return of(this.hasPermission(expected));
                }
                return of(false);
            }),
            tap(hasAccess => {
                if (!hasAccess) {
                    this._router.navigate(["/organization/list"]);
                }
            })
        );
    }

    public isAllowedOrganization(organizationId: number): Observable<boolean> {
        return this._organizationPermissions.allowedOrganizations$.pipe(
            map((allowedOrganizations: NameId[]) => {
                return allowedOrganizations.some(org => org.id === organizationId);
            })
        );
    }

    public hasPermission(expectedPermissions: string[]): boolean {
        return this._organizationPermissions.hasPermission(expectedPermissions);
    }
}
